import React from 'react';
import Icon from '../../../components/AppIcon';

const NavTabItem = ({ tab, isActive, onClick, badge }) => {
  return (
    <button
      onClick={onClick}
      className={`flex-1 flex flex-col items-center justify-center gap-1 min-h-[60px] py-2 px-1 relative transition-all duration-200 active:scale-95 ${
        isActive ? 'text-accent' : 'text-muted-foreground'
      }`}
      aria-label={tab?.label}
      aria-current={isActive ? 'page' : undefined}
    >
      {/* Active indicator bar at top */}
      <span
        className={`absolute top-0 left-1/2 -translate-x-1/2 h-0.5 rounded-full bg-accent transition-all duration-300 ${
          isActive ? 'w-8 opacity-100' : 'w-0 opacity-0'
        }`}
      />

      {/* Icon container */}
      <div className={`relative flex items-center justify-center w-7 h-7 rounded-xl transition-all duration-200 ${
        isActive ? 'bg-accent/10' : ''
      }`}>
        <Icon
          name={tab?.icon}
          size={20}
          className={`transition-colors duration-200 ${
            isActive ? 'text-accent' : 'text-muted-foreground'
          }`}
        />
        {/* Badge */}
        {badge > 0 && (
          <span className="absolute -top-1 -right-1 min-w-[16px] h-4 bg-red-500 text-white text-[9px] font-bold rounded-full flex items-center justify-center px-0.5 leading-none">
            {badge > 99 ? '99+' : badge}
          </span>
        )}
      </div>

      {/* Label */}
      <span className={`text-[10px] font-semibold leading-none tracking-tight transition-colors duration-200 ${
        isActive ? 'text-accent' : 'text-muted-foreground'
      }`}>
        {tab?.label}
      </span>
    </button>
  );
};

export default NavTabItem;
